module.exports = __webpack_public_path__ + "img/it_get.dd7907b.png";